<div id="passepartout">
  <app-topbar [lang]="selectedLanguage" [showMyNusach]="showMyNusach"></app-topbar>
  <app-left-sidebar [lang]="selectedLanguage"></app-left-sidebar>
  <app-right-sidebar [lang]="selectedLanguage" (changeLanguageEvent)="change($event)"></app-right-sidebar>
  <app-footer [lang]="selectedLanguage"></app-footer>
</div>
